import { Link } from "react-router-dom";
import { SENFULLY_APP_URL } from "../appConfig";
import { Icon } from "./Icon";
import { PhoneFrame } from "./PhoneFrame";
import "./styles/Hero.css";

export function Hero() {
  return (
    <section className="hero container" aria-labelledby="hero-title">
      <div className="hero__surface">
        <div className="hero__copy">
          <p className="hero__chip">By invitation</p>
          <h1 id="hero-title" className="hero__title">
            Everyone who loves them,
            <span className="hero__title-accent"> on the same page.</span>
          </h1>
          <p className="hero__lead">
            SENfully helps families of children with autism and SEND. A talking picture board for your child, their profile and key dates
            in one place, a private family feed, plain-English SEND guides, and a community of families who get it.
          </p>
          <div className="hero__actions">
            <Link to="/get-senfully" className="btn btn--light btn--lg">
              Get SENfully
              <Icon name="arrow-right" size={18} />
            </Link>
            <a href={SENFULLY_APP_URL} className="btn btn--outline-light btn--lg">Log in</a>
          </div>
          <ul className="hero__notes">
            <li><Icon name="phone" size={16} /> Works on iPhone and Android</li>
            <li><Icon name="offline" size={16} /> The board works offline</li>
            <li><Icon name="install" size={16} /> Installs from your browser</li>
          </ul>
        </div>

        <div className="hero__visual" aria-hidden="false">
          <PhoneFrame className="hero__phone hero__phone--back" src="/screens/board.jpg" alt="A child's SENfully talking board" isEager />
          <PhoneFrame className="hero__phone hero__phone--front" src="/screens/home.jpg" alt="The SENfully home screen for a parent" isEager />
        </div>
      </div>
    </section>
  );
}
